export default "__VITE_ASSET__844ca2ed__"